import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http'; // ADD : Service に影響する為、追加
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

import { CdkTableModule } from '@angular/cdk/table';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';

//grid
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { jqxButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxbuttons';
import { jqxDropDownListComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxdropdownlist';
import { jqxInputComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxinput';
import { jqxWindowComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxwindow';
import { jqxRadioButtonComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxradiobutton';
import { jqxFormComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxform';
import { jqxEditorComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxeditor';
import { jqxCheckBoxComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxcheckbox';
import { jqxLoaderComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxloader';

// Activate
jqx.credits = "75CE8878-FCD1-4EC7-9249-BA0F153A5DE8";
// Activate (For the version v7.1.0 and older versions you should use:)
//jqx.credits = "12F129D4-0E1B-44B8-9BBB-BB4CF78CC6BA"; 

//Login and auth
import { AuthGuard } from './services/auth-guard.service';
import { JwtHelper } from 'angular2-jwt';
import { LoginComponent } from './login/login.component';
import { AuthService } from './services/auth.service';

//Contract
import { ContractListComponent, PopupContractComponent, PopupEmailComponent } from './contract/contract-list.component';

//Machine
import { MachineListComponent, PopupMachineComponent } from './machine/machine-list.component';

//Support
import { SupportListComponent, PopupSupportComponent } from './support/support-list.component';

//Agent Commission
import { CommissionListComponent } from './commission/commission-list.component';

//Master
import { UserListComponent, PopupUserComponent } from './master/user-list.component';
import { RemindListComponent, PopupRemindComponent } from './master/remind-list.component';
import { PaymentListComponent, PopupPaymentComponent } from './master/payment-list.component';
import { SymptomListComponent, PopupSymptomComponent } from './master/symptom-list.component';
import { AgentListComponent, PopupAgentComponent } from './master/agent-list.component';
import { AgentPersonListComponent, PopupAgentPersonComponent } from './master/agent-person-list.component';
import { PlanListComponent, PopupPlanComponent } from './master/plan-list.component';
import { CustomerListComponent, PopupCustomerComponent } from './master/customer-list.component';
import { DeviceListComponent, PopupDeviceComponent } from './master/device-list.component';
import { ItemListComponent, PopupItemComponent } from './master/item-list.component';
import { CommissionPlanListComponent, PopupCommissionPlanComponent } from './master/commission-plan-list.component';
import { TermListComponent, PopupTermComponent } from './master/term-list.component';
import { StatusListComponent, PopupStatusComponent } from './master/status-list.component';

//Service
import { ContractService } from './services/contract-service';
import { MachineService } from './services/machine-service';
import { SupportService } from './services/support-service';
import { CommissionService } from './services/commission-service';
import { CommonService } from './services/common-service';

import { ReportService } from './services/report-service';
import { MasterService } from './services/master-service';

//Aunglar Material
import {
  MatAutocompleteModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatFormFieldModule,
} from '@angular/material';


@NgModule({
  declarations: [
    LoginComponent,
    AppComponent,
    NavMenuComponent,

    jqxGridComponent,
    jqxButtonComponent,
    jqxDropDownListComponent,
    jqxInputComponent,
    jqxWindowComponent,
    jqxRadioButtonComponent,
    jqxFormComponent,
    jqxEditorComponent,
    jqxCheckBoxComponent,
    jqxLoaderComponent,

    ContractListComponent,

    MachineListComponent,
    SupportListComponent,
    CommissionListComponent,

    UserListComponent,
    RemindListComponent,

    PaymentListComponent,
    SymptomListComponent,
    AgentListComponent,
    AgentPersonListComponent,
    PlanListComponent,
    CustomerListComponent,
    PopupCustomerComponent,
    DeviceListComponent,
    ItemListComponent,
    CommissionPlanListComponent,
    TermListComponent,
    StatusListComponent,

    PopupMachineComponent,
    PopupContractComponent,
    PopupEmailComponent,
    PopupSupportComponent,
    PopupRemindComponent,

    PopupUserComponent,
    PopupSymptomComponent,
    PopupPaymentComponent,
    PopupAgentComponent,
    PopupAgentPersonComponent,
    PopupPlanComponent,
    PopupDeviceComponent,
    PopupItemComponent,
    PopupCommissionPlanComponent,
    PopupTermComponent,
    PopupStatusComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    HttpModule,　// ADD : Service に影響する為、追加
    FormsModule,
    RouterModule.forRoot([
      { path: '', component: ContractListComponent, pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'login', component: LoginComponent },
      { path: 'home', component: ContractListComponent, canActivate: [AuthGuard] },

      { path: 'contract/contract-list', component: ContractListComponent, canActivate: [AuthGuard] },

      { path: 'machine/machine-list', component: MachineListComponent, canActivate: [AuthGuard] }, 
      { path: 'support/support-list', component: SupportListComponent, canActivate: [AuthGuard] },
      { path: 'commission/commission-list', component: CommissionListComponent, canActivate: [AuthGuard]},

      { path: 'master/user-list', component: UserListComponent, canActivate: [AuthGuard] },
      { path: 'master/remind-list', component: RemindListComponent, canActivate: [AuthGuard] },
      { path: 'master/payment-list', component: PaymentListComponent, canActivate: [AuthGuard] },
      { path: 'master/symptom-list', component: SymptomListComponent, canActivate: [AuthGuard] },
      { path: 'master/agent-list', component: AgentListComponent, canActivate: [AuthGuard] },
      { path: 'master/agent-person-list', component: AgentPersonListComponent, canActivate: [AuthGuard] }, 
      { path: 'master/plan-list', component: PlanListComponent, canActivate: [AuthGuard] }, 
      { path: 'master/commission-plan-list', component: CommissionPlanListComponent, canActivate: [AuthGuard] }, 
      { path: 'master/customer-list', component: CustomerListComponent, canActivate: [AuthGuard] },
      { path: 'master/device-list', component: DeviceListComponent, canActivate: [AuthGuard] },
      { path: 'master/item-list', component: ItemListComponent, canActivate: [AuthGuard] }, 
      { path: 'master/term-list', component: TermListComponent, canActivate: [AuthGuard] },
      { path: 'master/status-list', component: StatusListComponent, canActivate: [AuthGuard] },

      { path: 'contract/popup-contract', component: PopupContractComponent, canActivate: [AuthGuard] },
      { path: 'contract/popup-email', component: PopupEmailComponent, canActivate: [AuthGuard] },

      { path: 'machine/popup-machine', component: PopupMachineComponent, canActivate: [AuthGuard] }, 
      { path: 'support/popup-support', component: PopupSupportComponent, canActivate: [AuthGuard] },

      { path: 'master/popup-user', component: PopupUserComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-remind', component: PopupRemindComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-payment', component: PopupPaymentComponent, canActivate: [AuthGuard] },
      { path: 'master/popup-Symptom', component: PopupSymptomComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-agent', component: PopupAgentComponent, canActivate: [AuthGuard] },
      { path: 'master/popup-agent-person', component: PopupAgentPersonComponent, canActivate: [AuthGuard] },
      { path: 'master/popup-plan', component: PopupPlanComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-commission-plan', component: PopupCommissionPlanComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-customer', component: PopupCustomerComponent, canActivate: [AuthGuard] },
      { path: 'master/popup-device', component: PopupDeviceComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-item', component: PopupItemComponent, canActivate: [AuthGuard] }, 
      { path: 'master/popup-term', component: PopupTermComponent, canActivate: [AuthGuard] },
      { path: 'master/popup-status', component: PopupStatusComponent, canActivate: [AuthGuard] }, 

    ]),
    CdkTableModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatFormFieldModule,
    ReactiveFormsModule
  ],
  entryComponents: [
    PopupMachineComponent,
    PopupContractComponent,
    PopupEmailComponent,
    PopupRemindComponent,
    PopupUserComponent,
    PopupPaymentComponent,
    PopupAgentComponent,
    PopupPlanComponent,
    PopupAgentPersonComponent,
    PopupCommissionPlanComponent,
    PopupCustomerComponent,
    PopupDeviceComponent,
    PopupItemComponent,
    PopupTermComponent,
    PopupSymptomComponent,
    PopupSupportComponent,
    PopupStatusComponent
  ],
  providers: [
    JwtHelper,
    AuthGuard,
    AuthService,
    ContractService,
    MachineService,
    SupportService,
    CommissionService,
    CommonService,

    ReportService,
    MasterService,

    //MomentModule,
    //MomentTimezoneModule,
  ],
  bootstrap: [
    AppComponent
  ],
  schemas: [
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts